<template>
  <div
    id="formulario-multiplo"
    :style="heightFix"
  >
    <div class="template-solicitacao-titulo">{{ titulo }}</div>

    <div class="template-solicitacao-box">
      <ButtonDefault
        :disabled="entradas.length === entradasMaximas"
        style="margin-top: 0;"
        title="+ Adicionar"
        @click="abrirModal"
      />
      <div class="template-solicitacao-box-text">
        {{ descricao }}
      </div>
    </div>

    <div class="template-solicitacao-form-list">
      <div
        v-if="entradas.length === 0"
        class="template-solicitacao-form-list-empty"
      >
        <div class="template-solicitacao-form-list-empty-circle">
          <svg-icone
            icone="img_helper_empty_default"
          />
        </div>

        <div class="template-solicitacao-form-list-empty-text">
          Ainda não há registros
        </div>

        <div class="template-solicitacao-form-list-empty-descricao">
          Cadastre seus regitros tocando no botão acima.
        </div>
      </div>

      <div
        v-else
        class="template-solicitacao-form-item-box"
      >
        <div class="template-solicitacao-form-item-box-titulo">Entradas adicionadas</div>
        <div
          v-for="(entrada, index) in manhiasEntradas"
          :key="index"
          style="margin-bottom: 10px;"
        >
          <EntradaMultiForm
            :client-key="aplicacao.clientKey"
            :entrada="entrada"
            :entrada-id="index"
            :form-id="formId"
            @remover="remover(index)"
          />
        </div>
      </div>
    </div>

    <DialogDefault
      ref="formularioModal"
      :closeOnClickModal="false"
      :open.sync="mostrarDialogForm"
      :title="titulo"
      :width="step.instrucoes ? '80%' : '50%'"
      @close="fecharDialogForm"
    >
      <el-row>
        <el-col
          :span="step.instrucoes ? 12 : 24"
        >
          <div
            :style="step.instrucoes ? 'padding-right: 30px' : ''"
          >
            <div
              v-if="internalLoading"
              style="height: 400px"
            />
            <div ref="formContairner"/>

            <ButtonDefault
              :disabled="internalLoading"
              style="margin-top: 30px;"
              title="Adicionar"
              @click="salvarDialog"
            />
          </div>
        </el-col>
        <el-col
          v-if="step.instrucoes"
          :span="12"
          style="border-left: 1px solid #EEEEEE;"
        >
          <div
            style="padding-left: 30px;"
            v-html="step.instrucoes"
          />
        </el-col>
      </el-row>
    </DialogDefault>

    <div
      style="width: 100%; display:flex; flex-flow: row nowrap; justify-content: space-evenly"
    >
      <ButtonLink
        :disabled="entradas.length === 0"
        border
        style="height: 34px; width: 48%; margin-top: 0;"
        texto="EXCLUIR TUDO"
        @click="removerTodos"
        secundaria
      />
      <ButtonDefault
        :disabled="entradas.length === 0"
        style="height: 34px; width: 48%; margin-top: 0;"
        :title="ultimoStep"
        @click="proximo"
      />
    </div>
  </div>
</template>
<script>
import ButtonDefault from '@/components/buttons/ButtonDefault'
import { mapGetters, mapState } from 'vuex'
import { initForm } from '@mobilesaude/form-builder-sdk'
import DialogDefault from '@/components/DialogDefault/DialogDefault'
import ButtonLink from '@/components/ButtonLink/ButtonLink'
import EntradaMultiForm from '@/components/TemplateSolicitacao/componentes/EntradaMultiForm'
import useAppDataDriver from '@/utils/useAppDataDriver'

export default {
  name: 'TemplateStepFormularioMultiplo',
  components: { EntradaMultiForm, ButtonLink, DialogDefault, ButtonDefault },
  props: {
    step: {
      type: Object
    },
    idFuncionalidade: {
      type: [Number, String],
      default: -23
    },
    idTipoOcorrencia: {
      type: [Number, String],
      default: 1
    },
    data: {
      default: () => ({})
    },
    beneficiarioSelecionado: {
      type: Object,
      default: undefined
    },
    stepCount: {
      type: [Number, String],
      default: 1
    },
    stepEnd: {
      type: [Number, String],
      default: 1
    }
  },
  data () {
    return {
      form: null,
      internalLoading: true,
      mostrarDialogForm: false,
      entradas: [],
      processando: false,
      formTimestamp: 1
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['aplicacao', 'estilo']),
    ...mapState('SetupApp', ['apiFormPreLoadData']),
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    },
    formId () {
      return this.step.formulario.idForm
    },
    titulo () {
      return this.step.formulario.titulo
    },
    descricao () {
      return this.step.formulario.descricao
    },
    entradasMaximas () {
      return this.step.formulario.entradasMaximas
    },
    heightFix () {
      if (this.mostrarDialogForm) {
        if (this.$refs.formularioModal) {
          const modalHeight = this.$refs.formularioModal.clientHeight
          const screenHeight = screen.availHeight - 100

          const height = screenHeight > modalHeight ? screenHeight : modalHeight + 100

          return {
            'min-height': `${height}px`
          }
        }
      }

      return {}
    },
    manhiasEntradas () {
      return this.entradas.map((v) => {
        return {
          ...v,
          index: JSON.stringify(v)
        }
      })
    },
    ultimoStep () {
      let texto = 'PRÓXIMO'
      if (this.stepCount === this.stepEnd) {
        texto = 'ENVIAR'
      }
      return texto
    },
    formDataAnterior () {
      const formularioAnterior = this.$route.query.formularioAnterior || {}
      return formularioAnterior.formData && formularioAnterior.formData[0]
    }
  },
  methods: {
    init () {
      this.processando = false
      this.entradas = this.data.formData || []
    },
    async initForm () {
      const loader = this.$loading({
        lock: true,
        fullscreen: true,
        customClass: 'myloading'
      })
      await this.preLoadData()

      this.formTimestamp = Date.now()
      let id = `form-container-${this.formTimestamp}`
      this.$refs.formContairner.innerHTML = `<div id="${id}"/>`
      this.internalLoading = true

      this.form = initForm({
        identifier: id,
        clientKey: this.aplicacao.clientKey,
        idForm: this.formId,
        colors: { ...this.formBuilderColors }
      })

      this.form.on('LOADING', async () => {
        this.form.renderForm(await this.getJsonInjetado())

        setTimeout(() => {
          this.internalLoading = false
          loader.close()
          document.querySelector('.v-modal').style = 'z-index: 2000;'
        }, 300)
      })
    },
    async getJsonInjetado () {
      const appDataDriver = useAppDataDriver()
      const keyCustomFields = await this.form.getKeyCustomFields()
      if (!Array.isArray(keyCustomFields.keyCustoms) || keyCustomFields.keyCustoms.length === 0) {
        return false
      }

      let payload = {
        camposFormbuiler: keyCustomFields.keyCustoms,
        beneficiarioSelecionado: this.beneficiarioSelecionado,
        integracao: this.jsonPreLoadData,
        formulario: this.formDataAnterior
      }

      return appDataDriver.formatJSON(payload)
    },
    abrirModal () {
      this.mostrarDialogForm = true
      setTimeout(() => {
        this.initForm()
      }, 300)
    },
    async salvarDialog () {
      const loader = this.$loading({
        lock: true,
        fullscreen: true,
        customClass: 'myloading'
      })

      const formData = await this.form.validateAll()

      if (!formData || !formData.status) {
        loader.close()
        return false
      }

      this.entradas.push(formData.data)

      setTimeout(() => {
        this.mostrarDialogForm = false
        loader.close()
      }, 300)
    },
    fecharDialogForm () {
      this.mostrarDialogForm = false
    },
    remover (index) {
      this.entradas.splice(index, 1)
    },
    removerTodos () {
      this.entradas = []
    },
    formatarValor (valor) {
      if (Array.isArray(valor)) {
        return valor[0].label[0]
      }
      return valor
    },
    async proximo () {
      if (this.processando) {
        return
      }
      this.processando = true
      this.$emit('proximo', {
        formData: this.entradas
      })
      setTimeout(() => {
        this.processando = false
      }, 100)
    },
    getKey (entrada, index) {
      return Math.random() + index + 1 + Date.now()
    },
    async preLoadData () {
      let payloadData = {}

      if (this.beneficiarioSelecionado && this.beneficiarioSelecionado.beneficiarioDados) {
        payloadData = {
          chaveUnica: this.beneficiarioSelecionado.chaveUnica,
          numeroContrato: this.beneficiarioSelecionado.numeroContrato,
          integracao: this.beneficiarioSelecionado.beneficiarioDados.integracao,
          formulario: this.formDataAnterior
        }
      }

      this.jsonPreLoadData = await this.apiFormPreLoadData.carregar(
        {
          payload: {
            idFuncionalidade: this.idFuncionalidade,
            idTipoOcorrencia: this.idTipoOcorrencia,
            idTipoSolicitacao: this.step.formulario.idSolicitacaoTemplateTipo || '',
            formulario: this.formDataAnterior,
            ...payloadData
          },
          handlerErrorIgnore: true
        })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
